(ns frontend.view.nev.kyc.process.editors
  (:require
   [frontend.view.nev.kyc.process.pep-editor :as pep-editor]
   [frontend.view.nev.kyc.process.ubo-editor :as ubo-editor]
   [frontend.view.nev.kyc.process.board-member-editor :as board-member-editor]
   [frontend.view.nev.kyc.process.smo-editor :as smo-editor]
   [frontend.view.nev.kyc.process.tax-country-editor :as tax-country-editor]
   [frontend.view.nev.kyc.process.source-allocation-split-editor :as source-allocation-split-editor]
   [frontend.view.nev.kyc.process.split-of-investment-portfolio-editor :as
    split-of-investment-portfolio-editor]
   [frontend.view.nev.kyc.process.multi-select-checkbox-editor :as multi-select-checkbox-editor]
   [frontend.view.nev.kyc.process.nationality-editor :as nationality-editor]
   [frontend.view.nev.kyc.process.generic-person-list-editor :as generic-person-list-editor]
   [frontend.view.nev.kyc.process.flow-through-jurisdiction-editor :as flow-through-jurisdiction-editor]
   [frontend.logging :as logging]
   [frontend.view.nev.kyc.process.string-array-editor :as string-array-editor]
   [frontend.view.nev.kyc.process.combo-checkbox-editor :as combo-checkbox-editor]
   [frontend.view.nev.kyc.process.type-of-controlling-person-editor :as type-of-controlling-person-editor]))

(defn complex-editor
  [{:keys [_kyc-entity-editor _kyc-process _process-id _state-atom _lang-kw question-attribute
           question-meta _answers-atom _mandatory? _read-only? _save!]
    :as   args}]
  (case question-attribute
    :kyc-legal-entity/pep-edn (pep-editor/view args)
    :kyc-legal-entity/ubo-edn (ubo-editor/view args)
    :kyc-legal-entity/board-members-edn (board-member-editor/view args)
    :kyc-legal-entity/smo-edn (smo-editor/view args)
    :kyc-legal-entity/tax-countries (tax-country-editor/view args)
    :kyc-person/ubo-edn (ubo-editor/view args)
    :kyc-person/pep-edn (pep-editor/view args)
    :kyc-person/tax-countries (tax-country-editor/view args)
    :kyc-tenant/ubo-edn (ubo-editor/view args)
    :contract-kyc/ubo-edn (ubo-editor/view args)
    :kyc-ubo/tax-countries (tax-country-editor/view args)
    :kyc-smo/tax-countries (tax-country-editor/view args)
    :kyc-controlling-person/tax-countries (tax-country-editor/view args)
    :kyc-legal-entity/source-of-funds-allocation-split (source-allocation-split-editor/view args)
    :kyc-legal-entity/split-of-investment-portfolio (split-of-investment-portfolio-editor/view args)
    :kyc-legal-entity/flow-through-ownership-jurisdictions (flow-through-jurisdiction-editor/view args)
    :kyc-legal-entity/substantial-us-owners-edn (generic-person-list-editor/substantial-us-owners-view args)
    :kyc-legal-entity/controlling-persons-edn (generic-person-list-editor/controlling-persons-view args)
    :kyc-controlling-person/lifeline-type-of-controlling-person-edn [type-of-controlling-person-editor/view args]

    (cond
      (-> question-meta
          :edn-data/type
          (= :edn-data.type/nationalities))
      [nationality-editor/view args]

      (-> question-meta
          :edn-data/type
          (= :edn-data.type/combo-checkbox-selection))
      [combo-checkbox-editor/view args]

      (-> question-meta
          :edn-data/type
          (= :edn-data.type/string-array))
      [string-array-editor/view args]

      (= :data.type/keyword-multi (:data/type question-meta))
      [multi-select-checkbox-editor/editor args]

      :else
      (logging/error "Unknown complex editor : " question-attribute " >> " question-meta))))
